module.exports = __webpack_public_path__ + "img/currency.fe18748b.svg";